/**
 * src/components/business-page/BusinessSidebar.js
 *
 * Columna izquierda: logo, nombre, categoría, WhatsApp, redes, descripción, mapa.
 * Props: { business }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { brandIcons, uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'

const SOCIAL_ICONS = {
    instagram: { icon: brandIcons.instagram, label: 'Instagram' },
    facebook:  { icon: brandIcons.facebook,  label: 'Facebook'  },
    tiktok:    { icon: brandIcons.tiktok,    label: 'TikTok'    },
    website:   { icon: brandIcons.website,   label: 'Sitio web' }
}

define('BusinessSidebar', ({ business }) => {
    const { name, category, location, whatsapp, social = {},
            logo, fullDescription, mapEmbed, mapLabel, mapUrl } = business

    /* ── Redes sociales ── */
    const socialLinks = Object.entries(SOCIAL_ICONS)
        .filter(([key]) => social[key])
        .map(([key, { icon, label }]) =>
            h('a', {
                className: 'biz-sidebar__social-btn',
                href: social[key],
                target: '_blank',
                rel: 'noopener',
                title: label,
                'aria-label': label,
                innerHTML: icon
            })
        )

    /* ── Tarjeta de identidad ── */
    const identity = h('div', { className: 'biz-sidebar__card' },
        h('div', { className: 'biz-sidebar__logo-wrap' },
            h('img', { src: logo, alt: name, className: 'biz-sidebar__logo' })
        ),
        h('h1', { className: 'biz-sidebar__name' }, name),
        h('p',  { className: 'biz-sidebar__meta' }, `${category} · ${location}`),
        h('a', {
            className: 'biz-sidebar__whatsapp',
            href: waLink(whatsapp),
            target: '_blank',
            rel: 'noopener',
            innerHTML: uiIcons.whatsapp + ' Contactar por WhatsApp' }),
        socialLinks.length
            ? h('div', { className: 'biz-sidebar__socials' }, ...socialLinks)
            : null
    )

    /* ── Descripción ── */
    const description = h('div', { className: 'biz-sidebar__card' },
        h('h2', { className: 'biz-sidebar__section-title' }, 'Descripción'),
        h('p',  { className: 'biz-sidebar__desc' }, fullDescription)
    )

    /* ── Mapa ── */
    const mapCard = h('div', { className: 'biz-sidebar__card' },
        h('h2', { className: 'biz-sidebar__section-title' }, 'Ubicación'),
        h('div', { className: 'biz-sidebar__map-wrap' },
            h('iframe', {
                src:             mapEmbed,
                className:       'biz-sidebar__map',
                loading:         'lazy',
                referrerpolicy:  'no-referrer-when-downgrade'
            })
        ),
        h('p', { className: 'biz-sidebar__map-label', innerHTML: uiIcons.pin + ' ' + mapLabel }),
        h('a', {
            className: 'biz-sidebar__map-btn',
            href: mapUrl,
            target: '_blank',
            rel: 'noopener',
            innerHTML: uiIcons.map + ' Cómo llegar' })
    )

    return h('aside', { className: 'biz-sidebar' },
        identity,
        description,
        mapCard
    )
})
